module.exports = __webpack_public_path__ + "img/accenture.78476a11.png";